import { useEffect, useState } from "react";
import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import { useDispatch } from "react-redux";
import cookies from "../utilities/Cookies";
import { updatedarkmode } from "../features/mode";
import { Container, Skeleton } from "@mui/material";
import Mode from "../components/styles/Mode";
import Countdown from "../components/Countdown";
import Button from "../components/Button";

let url = ''

const BuyerBnCTYP = () => {

    const dispatch = useDispatch()

    const [firstname, setFirstName] = useState(null)
    const [lastname, setLastName] = useState(null)

    const [running, setRunning] = useState(true)

    const [loading, setLoading] = useState(true)


    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))


        const urlParams = new URLSearchParams(window.location.search)
        setFirstName(urlParams.get('first_name'))
        setLastName(urlParams.get('last_name'))
        url = urlParams.get('url')
        setLoading(false)


        if (url) {
            setTimeout(() => {
                window.location.href = url
            }, 7000);
        }
        // eslint-disable-next-line
    }, [])
    return (
        <Mode>
            <div className="zoom-90">
                {loading && (
                    <Container>
                        <div className="margin-auto" style={{ maxWidth: '400px', padding: '10px' }}>
                            <Skeleton variant="rounded" width={"100%"} height={200} />
                            <Spacebox padding="10px" />
                            <Skeleton variant="rounded" width={100} height={15} />
                            <Spacebox padding="10px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                            <Spacebox padding="5px" />
                            <Skeleton variant="rounded" width="100%" height={10} />
                        </div>
                    </Container>
                )}
                {!loading && <div className="margin-auto error-div" style={{ textAlign: 'center', padding: 20 }}>
                    <Spacebox padding="20px" />
                    <Flexbox alignItems="center" justifyContent="center">
                        <img src="/assets/color-logo.png" alt="Final debt relief" style={{ width: 200 }} />
                    </Flexbox>
                    <Spacebox padding="10px" />
                    <Flexbox justifyContent="space-between" alignItems="center">
                        <div>
                            <span>
                                Name: <b>{firstname} {lastname}</b>
                            </span>
                            <Spacebox padding="0px" />
                            <span>
                                Date: <b>{(new Date()).toString().substring(4, 16)}</b>
                            </span>
                        </div>
                        <div>
                            <span>Powered by:</span>
                            <Spacebox padding="0px" />
                            <img src="/assets/turbo-debt.png" alt="turbo debt" style={{ width: 150 }} />
                        </div>
                    </Flexbox>
                    <Spacebox padding="20px" />
                    <div className="margin-auto" style={{ textAlign: 'center', maxWidth: 500 }}>
                        <div style={{ width: 'fit-content' }} className="margin-auto">
                            <img src="/assets/green-check.png" alt="check" style={{ width: 40 }} />
                        </div>
                        <Spacebox padding="20px" />
                        <span style={{ fontSize: 25, fontWeight: 600 }} className="trade-green">
                            Thank You — We’ve Received Your Info!
                        </span>
                        <Spacebox padding="10px" />
                        <span>
                            A Consolidation Specialist is reviewing your details and will be calling you within the next few minutes to walk you through your options.
                        </span>
                        <Spacebox padding="10px" />
                        <span style={{ fontSize: 22, fontWeight: 600 }} className="trade-green">
                            📞 Want to {url === '' ? 'speak' : 'chat'} right away?
                        </span>
                        <Spacebox padding="10px" />
                        {running && <span>
                            You'll be redirected shortly, please wait... <Countdown seconds={8} onComplete={() => setRunning(false)} isRunning={running} style={{ fontStyle: 'bold' }} />
                        </span>}
                        {(!running && url) && <div style={{ textAlign: 'center' }}>
                            <span>If you were not redirected automatically, kindly use the button below to proceed to your secure live chat with an agent</span>
                            <Spacebox padding="5px" />
                            <Flexbox justifyContent="center">
                                <Button
                                    handleClick={() => window.location.replace(url)}
                                    className="signature-btn"
                                    style={{ background: 'var(--secondary)', color: 'white', width: 'fit-content', padding: '10px 30px', borderRadius: '100px', fontSize: '1.1rem' }}
                                >
                                    Proceed to Secure Live Chat
                                </Button>
                            </Flexbox>
                            <Spacebox padding="10px" />
                        </div>}
                        <div>
                            <Spacebox padding="10px" />
                            <div style={{ borderRadius: 20, height: 10, overflow: 'hidden' }} className="bg-shade">
                                <div style={{ background: 'var(--primary)', width: '40%', height: 10 }}></div>
                            </div>
                        </div>
                        <Spacebox padding="20px" />
                    </div>
                </div>}
            </div>
        </Mode>
    );
}

export default BuyerBnCTYP;